import { apiClient, createSession, createSuccessResponse, handleApiError } from "./api";

const userService = {

    async signIn(user) {
        try {
            var users = {
                login: user.login,
                password: user.password
            }

            var retorno = await createSession(users);

            console.log(retorno)

            return retorno;
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listarUser(page = 1, pageSize = 10, filters = {}, sortBy = null, sortOrder = null){
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                pageSize: pageSize.toString(),
                ...filters
            });

            // Adicionar parâmetros de ordenação se fornecidos
            if (sortBy) {
                params.append('sortBy', sortBy);
            }
            if (sortOrder) {
                params.append('sortOrder', sortOrder);
            }

            var retorno = await apiClient.get(`/user?${params.toString()}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            console.error("❌ [userService] Erro ao listar usuários:", processedError);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    /**
     * @function getCurrentUser
     * @description Obtém o usuário atual
     * @returns {Object} - Objeto com o usuário atual
     */
    async getCurrentUser() {
        try {
            var retorno = await apiClient.get("/user/me");
            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async editUser(id) {
        try {
            var retorno = await apiClient.get("/user/" + id);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async save(user) {
        try {
            console.log(user)

            var retorno = await apiClient.post("/user", user);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async listFilter(id) {
        try {
            console.log(id)

            var retorno = await apiClient.get('/user/filter/' + id);

            return retorno.data;
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },


    async update(user) {
        try {
            console.log(user)

            var retorno = await apiClient.put("/user", user);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async delete(iduser) {
        try {
            console.log(iduser)

            var retorno = await apiClient.delete("/user/" + iduser);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    }

}

export default userService;